import { render, staticRenderFns } from "./specialzone.vue?vue&type=template&id=affdda98&scoped=true"
import script from "./specialzone.vue?vue&type=script&lang=ts"
export * from "./specialzone.vue?vue&type=script&lang=ts"
import style0 from "./specialzone.vue?vue&type=style&index=0&id=affdda98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affdda98",
  null
  
)

export default component.exports